/*
 * @param {string} source
 * @param {string} target
 * @return {boolean}
 * */
export function includeSubstring(source, target) {
  source = source.toLowerCase();
  target = target.toLowerCase();
  return source.indexOf(target) !== -1;
}
